import { render, staticRenderFns } from "./ShuJu.vue?vue&type=template&id=50064989&scoped=true"
import script from "./ShuJu.vue?vue&type=script&lang=js"
export * from "./ShuJu.vue?vue&type=script&lang=js"
import style0 from "./ShuJu.vue?vue&type=style&index=0&id=50064989&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50064989",
  null
  
)

export default component.exports